// src/screens/customer/auth/VerifyOtp.jsx

import { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/forgetPassword/ForgotPassword.css";

export default function VerifyOtp() {
  const { baseUrl } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // If someone lands here directly without going through step 1, send them back
  useEffect(() => {
    if (!email) {
      navigate("/forgot-password");
    }
  }, [email, navigate]);

  const handleVerify = () => {
    if (!otp.trim()) {
      setErrors({ otp: "OTP is required." });
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("otp", otp);

    axios
      .post(`${baseUrl}/customer/forgot-password/verifyOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        setIsSubmitting(false);
        if (response.data.success) {
          navigate("/forget-password/reset-password", {
            state: { email, otp },
          });
        } else {
          setErrors({
            general: response.data.message || "Invalid OTP. Please try again.",
          });
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        setErrors({
          general:
            error.response?.data?.message ||
            "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div className="fp-page">
      <div className="fp-card">
        <button
          className="fp-back-arrow"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
        </button>

        <div className="fp-header">
          <h2 className="fp-title">Enter OTP</h2>
          <p className="fp-subtitle">We sent a 6-digit code to {email}</p>
        </div>

        <div className="fp-form-body">
          {errors.general && (
            <div className="fp-general-error">⚠ {errors.general}</div>
          )}

          <div className="fp-field">
            <label className="fp-label" htmlFor="fp-otp">
              OTP Code
            </label>
            <div className="fp-input-wrap">
              <span className="fp-input-icon">
                <ShieldCheck size={16} />
              </span>
              <input
                id="fp-otp"
                type="text"
                inputMode="numeric"
                maxLength={6}
                className={`fp-input${errors.otp ? " fp-input-error" : ""}`}
                placeholder="123456"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value.replace(/\D/g, ""));
                  if (errors.otp) setErrors((p) => ({ ...p, otp: "" }));
                }}
              />
            </div>
            {errors.otp && <span className="fp-error-msg">⚠ {errors.otp}</span>}
          </div>

          <button
            className="fp-submit-btn"
            type="button"
            onClick={handleVerify}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Verifying…" : "Verify OTP"}
          </button>
        </div>
      </div>
    </div>
  );
}
